import axios from "axios";
import { getToken } from "./auth.service";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_BACKEND || process.env.ENTER_BACKEND_URL || 'http://localhost:3001'
});

api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
